var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#F4EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14L16.0934 24.6879C15.7446 25.1064 15.5702 25.3157 15.5676 25.4925C15.5652 25.6461 15.6337 25.7923 15.7532 25.8889C15.8907 26 16.1632 26 16.708 26H24L23 34L31.9065 23.3121C32.2553 22.8936 32.4297 22.6843 32.4324 22.5075C32.4347 22.3539 32.3663 22.2077 32.2467 22.1111C32.1092 22 31.8368 22 31.292 22H24L25 14Z",
    stroke: "#7F56D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapIcon);
export default __webpack_public_path__ + "static/media/zap-icon.8cb31ea07e4268cb4ffc859091f5b536.svg";
export { ForwardRef as ReactComponent };